import { useEffect } from "react";

/**
 * @param {boolean} enabled
 */
export function useBeforeUnloadWhen(enabled) {
  useEffect(() => {
    if (!enabled) {
      return undefined;
    }
    const handler = (event) => {
      event.preventDefault();
      event.returnValue = "";
    };
    window.addEventListener("beforeunload", handler);
    return () => {
      window.removeEventListener("beforeunload", handler);
    };
  }, [enabled]);
}
